import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 20v-16h-2a4 4 0 0 0 -4 4v1a4 4 0 0 0 4 4h2","key":"svg-0"}],["path",{"d":"M9 20l3 -7","key":"svg-1"}]]

/**
 * IconBrandYandex
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQteWFuZGV4Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xNSAyMHYtMTZoLTJhNCA0IDAgMCAwIC00IDR2MWE0IDQgMCAwIDAgNCA0aDIiIC8+CiAgPHBhdGggZD0iTTkgMjBsMyAtNyIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/brand-yandex
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandYandex = createReactComponent('outline', 'brand-yandex', 'BrandYandex', __iconNode);

export default IconBrandYandex;